import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import PostInspectionDiyHoldbacksV3 from "./component";
import { getPartyPeshifaqs } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        priceBreakup,
        inspectionResponse
    }
}) => ({
    priceBreakup,
    inspectionResponse
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getPartyPeshifaqsConnect: getPartyPeshifaqs
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyHoldbacksV3));
